import { useTranslations } from "next-intl";
import { montserrat } from "utils";

export function ServiceFeePopoverContent() {
  const t = useTranslations();

  const optionClassName = "flex flex-row items-center gap-2";
  return (
    <div className="p-2 rounded-xl max-w-[32rem]">
      <p>{t("Pricing.popover.serviceFeeTopDescription")}</p>
      <ul>
        <li className={optionClassName}>
          <span className="text-base">✔️</span>
          <span className={`${montserrat.className} text-base`}>
            {t("Pricing.popover.serviceFeeOptionFirst")}
          </span>
        </li>
        <li className={optionClassName}>
          <span className="text-base">✔️</span>
          <span className={`${montserrat.className} text-base`}>
            {t("Pricing.popover.serviceFeeOptionSecond")}
          </span>
        </li>
        <li className={optionClassName}>
          <span className="text-base">❌</span>
          <span className={`${montserrat.className} text-base`}>
            {t("Pricing.popover.serviceFeeOptionThird")}
          </span>
        </li>
      </ul>
      <p>{t("Pricing.popover.serviceFeeBottomDescription")}</p>
    </div>
  );
}
